function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgForestationLight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "100%",
    height: "100%",
    viewBox: "0 0 679 746",
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      strokeLinejoin: "round",
      strokeMiterlimit: 2
    },
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("rect", {
    id: "Forestation",
    x: 0.891,
    y: 0.983,
    width: 677.134,
    height: 744.088,
    style: {
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M216.989,669.822C227.762,650.829 272.816,636.563 326.692,636.563C366.994,636.563 402.359,644.546 422.134,656.52C436.467,653.117 453.45,651.147 471.652,651.147C522.81,651.147 564.343,666.71 564.343,685.879C564.343,703.727 528.336,718.449 482.076,720.393L482.073,720.393C478.656,720.537 475.177,720.611 471.652,720.611C467.723,720.611 463.851,720.519 460.047,720.341L159.337,719.622L158.826,719.621C115.479,719.518 80.372,706.3 80.372,690.033C80.372,673.702 115.755,660.444 159.337,660.444C182.073,660.444 202.579,664.052 216.989,669.822Z",
    style: {
      fill: "rgb(204,204,204)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M344.867,347.037L308.518,347.037C308.518,347.037 299.542,603.097 297.366,665.159C297.243,668.677 298.554,672.093 300.999,674.625C303.444,677.157 306.812,678.587 310.332,678.587L343.053,678.587C346.572,678.587 349.941,677.157 352.386,674.625C354.83,672.093 356.141,668.677 356.018,665.159C353.843,603.097 344.867,347.037 344.867,347.037Z",
    style: {
      fill: "rgb(144,77,46)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M486.673,411.859L456.631,411.859C456.631,411.859 449.426,617.398 447.497,672.451C447.373,675.969 448.684,679.385 451.129,681.917C453.574,684.449 456.942,685.879 460.462,685.879L482.843,685.879C486.362,685.879 489.731,684.449 492.175,681.917C494.62,679.385 495.931,675.969 495.808,672.451C493.878,617.398 486.673,411.859 486.673,411.859Z",
    style: {
      fill: "rgb(144,77,46)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M379.679,223.259C385.381,177.557 424.413,142.142 471.652,142.142C518.891,142.142 557.924,177.557 563.626,223.259C605.416,232.24 636.781,269.428 636.781,313.884C636.781,324.151 635.108,334.031 632.02,343.265C647.533,359.839 657.034,382.106 657.034,406.575C657.034,457.732 615.501,499.266 564.343,499.266C541.952,499.266 521.404,491.309 505.38,478.074C494.93,482.165 483.552,484.412 471.652,484.412C459.753,484.412 448.374,482.165 437.924,478.074C421.901,491.309 401.353,499.266 378.961,499.266C327.804,499.266 286.27,457.732 286.27,406.575C286.27,382.106 295.772,359.839 311.285,343.265C308.197,334.031 306.524,324.151 306.524,313.884C306.524,269.428 337.888,232.24 379.679,223.259Z",
    style: {
      fill: "rgb(78,196,143)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M172.133,456.591L146.54,456.591C146.54,456.591 140.568,626.952 138.828,676.605C138.705,680.122 140.016,683.539 142.46,686.071C144.905,688.603 148.274,690.033 151.793,690.033L166.88,690.033C170.4,690.033 173.768,688.603 176.213,686.071C178.658,683.539 179.969,680.122 179.846,676.605C178.105,626.952 172.133,456.591 172.133,456.591Z",
    style: {
      fill: "rgb(144,77,46)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M128.224,269.069C129.652,267.347 131.13,265.671 132.656,264.041C128.919,252.869 126.895,240.915 126.895,228.492C126.895,174.702 164.844,129.707 215.409,118.841C222.308,63.543 269.536,20.693 326.692,20.693C383.849,20.693 431.076,63.543 437.976,118.841C447.406,120.867 456.397,124.081 464.786,128.318C416.786,131.373 377.376,166.214 367.375,211.991C323.999,225.552 292.48,266.064 292.48,313.884C292.48,322.84 293.587,331.54 295.67,339.855C289.532,347.504 284.426,356.017 280.565,365.177C272.094,357.319 262.146,351.031 251.187,346.778C246.561,300.154 207.174,263.685 159.337,263.685C148.42,263.685 137.944,265.584 128.224,269.069Z",
    style: {
      fill: "rgb(34,181,115)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M290.225,464.412C278.041,492.305 250.195,511.823 217.827,511.823C194.646,511.823 173.784,501.812 159.337,485.886C144.89,501.812 124.028,511.823 100.847,511.823C57.265,511.823 21.882,476.439 21.882,432.857C21.882,396.353 46.705,365.601 80.374,356.577C80.372,356.383 80.372,356.187 80.372,355.991C80.372,312.409 115.755,277.026 159.337,277.026C202.919,277.026 238.302,312.409 238.302,355.991C238.302,356.187 238.301,356.383 238.299,356.577C253.201,360.571 266.37,368.822 276.418,379.941C274.209,388.453 273.034,397.378 273.034,406.575C273.034,427.908 279.354,447.776 290.225,464.412Z",
    style: {
      fill: "rgb(123,211,171)"
    }
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgForestationLight);
export default __webpack_public_path__ + "static/media/forestation-light.fa6856fbcce5117fc12af22eb824d816.svg";
export { ForwardRef as ReactComponent };